import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

export const fileUrl = (path) => {
  const token = localStorage.getItem("ae_token");
  return `${API}/files/${path}${token ? `?auth=${token}` : ""}`;
};

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ae_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
